import React from 'react';
import { Fragment } from 'components';
import { isEmpty, get, isArray } from 'lodash-es';
import styles from './styles.module.scss';
import Icon from 'components/antd/Icon/Icon';
import classNames from 'classnames';
import { ThemeContext } from 'app-themes';
import { FlightData, GoogleAddressAndFlightData, SimpleFlight } from 'app-types';
import { hasFlight, isFlightItem, getPlaceAddress, getPlaceId } from 'utils/flightsUtils';
import { getFrom } from 'utils/utils';
import { IconType } from 'components/antd/Icon/IconTypes';

interface Props {
	showShortAddress?: boolean;
	addresses: Array<GoogleAddressAndFlightData | FlightData | undefined>;
	airportTypes?: {
		[label: string]: string;
	};
	addressesObj?: {
		[label: string]: GoogleAddressAndFlightData | string | undefined;
	};
}

export class AddressesView extends React.Component<Props> {
	static contextType = ThemeContext;

	getLocationType(isFlight: boolean): keyof IconType {
		return isFlight ? 'plane' : 'location';
	}

	getAirportCode(code?: string) {
		if (code) {
			return ` [${code}],`;
		}
		return ',';
	}

	getTerminalNumber(terminal?: string) {
		if (terminal) {
			return `T${terminal},`;
		}
		return 'T';
	}

	getAddresses() {
		const { addressesObj } = this.props;
		let addresses: any = this.props.addresses;
		if (addressesObj && !isEmpty(addressesObj)) {
			// in order to handle airport types we need work with addressesObj
			addresses = Object.entries(addressesObj);
		}
		return addresses;
	}

	getSingleAddress(addressInit: any) {
		if (isArray(addressInit)) {
			// parse addressesObj item to needed values
			return addressInit[1];
		}

		return addressInit;
	}

	getPlaceAddressWithAirportType(addressInit: any, isNotLast: boolean) {
		const { airportTypes } = this.props;

		let label;
		if (isArray(addressInit)) {
			// parse addressesObj item to needed values
			label = addressInit[0];
		}

		return getPlaceAddress(
			this.getSingleAddress(addressInit),
			isNotLast,
			airportTypes && label && airportTypes[label]
		);
	}

	render() {
		const theme = this.context;

		const { showShortAddress } = this.props;

		const addresses = this.getAddresses();
		if (isEmpty(addresses)) {
			return null;
		}
		let addressesLength = addresses.length;

		return addresses.map((addressInit: any, index: number) => {
			const address = this.getSingleAddress(addressInit);
			if (!address) {
				return null;
			}
			const isFlight = hasFlight(address) || isFlightItem(address);
			const flight = getFrom<SimpleFlight>(get(address, 'flight'));
			const isShortAddressView = showShortAddress && addressesLength > 2;
			const isMiddlePoint = index !== 0 && index !== addressesLength - 1;
			if (isShortAddressView && isMiddlePoint) {
				return null;
			}
			return (
				<Fragment key={`${getPlaceId(address)}-${index}`}>
					<span
						className={classNames(styles.tripDetailsPoint, {
							[styles[`tripDetailsPoint-${theme}`]]: theme !== '',
						})}
					>
						<Icon type={this.getLocationType(isFlight)} />
						<span className={styles.tripDetailsAddress}>
							{isFlightItem(address) ? (
								<>
									<span className={styles.tripDetailsStreet}>
										{address.flightNumber}
									</span>
									<span className={styles.tripDetailsCity}>
										<div>
											{this.getPlaceAddressWithAirportType(
												addressInit,
												index !== addressesLength - 1
											)}
										</div>
									</span>
								</>
							) : isFlight ? (
								<>
									<span className={styles.tripDetailsStreet}>
										{flight('flightNumber')}
									</span>
									<span className={styles.tripDetailsCity}>
										<div>{flight('airportAddress')}</div>
									</span>
								</>
							) : (
								<>
									<span className={styles.tripDetailsStreet}>{address.name}</span>
									<span className={styles.tripDetailsCity}>
										{address.fullAddress}
									</span>
								</>
							)}
						</span>
						{index !== addressesLength - 1 && (
							<span
								className={classNames(styles.tripDetailsConnect, {
									isShortAddressView,
								})}
							>
								<span />
							</span>
						)}
					</span>
				</Fragment>
			);
		});
	}
}
